import 'babel-polyfill';
import 'es6-promise/auto';
import Vue from 'vue'
import App from './App.vue'
import axios from './common/axios';
import router from './common/router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {urls} from './common/apiUrl.js'
import Utils from './common/utils.js';
import{commonModeule} from './common/mixin'

Vue.use(Utils);
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.$urls = urls
Vue.mixin(commonModeule)

Vue.config.errorHandler = function (err, vm, info) {
  console.error('Error:', err, 'Vue instance:', vm, 'Info:', info)
  // 在这里可以添加自定义的错误处理逻辑，比如记录日志或者展示一个友好的错误页面
}

new Vue({
 router,
  render: h => h(App),
}).$mount('#app')
